import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IUpdateSelectedShuttlesActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/UpcomingPastBookingActionParams";

class UpdateSelectedShuttlesAction extends BaseAction<void, IUpdateSelectedShuttlesActionParams> {

    override async run(): Promise<void> {
        try {
            const { selectedShuttles } = this.params!;
            updateRecoilState("selectedShuttlesAtom", selectedShuttles);
        } catch (error) {
            console.error("Error updating selected shuttles:", error);
        }
    }
}

export const updateSelectedShuttlesAction = new UpdateSelectedShuttlesAction();

